import { css } from '@firebolt-dev/css'

export function UIEditorFieldBtn({ label, onClick }) {
  return (
    <div
      className='fieldbtn'
      css={css`
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--bg4);
        border-radius: 5px;
        height: 34px;
        span {
          // ...
        }
        &:hover {
          cursor: pointer;
          background: var(--bg5);
        }
      `}
      onClick={onClick}
    >
      <span>{label}</span>
    </div>
  )
}
